module.exports = __webpack_public_path__ + "static/img/Bachelor_010463.8ae7c3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010463.jpg
// module id = 169
// module chunks = 0